<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button type="primary" v-role="['1', '3']" class="add" size="small" @click="addRebate">
        <i class="el-icon-plus"></i>
        新增返点比例
      </el-button>
      <el-button type="danger" v-role="['1', '3']" size="small" class="delete" @click="delMulData">
        <i class="el-icon-delete"></i>删除
      </el-button>
      <el-switch @change="setRebateStatus" style="margin-left: 10px" v-model="showMatchRebate" active-text="显示代表队返点"
        inactive-text="取消代表队显示返点" active-color="#13ce66" inactive-color="#ff4949">
      </el-switch>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input placeholder="请输入比例名称" clearable v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-button type="primary" size="small" @click="doSearch" class="queryBtn">查询</el-button>
        </el-form>
      </div>
    </div>
    <div>
      <el-table ref="multipleTable" border :data="tableListData" style="width: 100%;position: relative;"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" min-width="40" align="center"></el-table-column>
        <el-table-column prop="name" align="center" label="名称"></el-table-column>
        <el-table-column prop="amount" align="center" label="返点门槛"></el-table-column>
        <el-table-column prop="rate" align="center" label="比例"></el-table-column>
        <el-table-column prop="operation" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteRebate(scope.row)" size="small">删除</el-button>
            <el-button type="text" size="small" @click="editRebate(scope.row)" >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="searchForm.page" :page-sizes="[15, 20, 50, 100]" :page-size="searchForm.pageSize" background
          layout="prev, pager, next,total, sizes, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <!--新增弹框-->
    <el-dialog :title="'新增返点比例'" :inline="true" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-position="right" label-width="110px" :rules="formRules" ref="form">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="返点门槛" prop="amount">
          <el-input v-model="form.amount" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="比例" prop="rate">
          <el-input v-model="form.rate" maxlength="255">
            <template slot="append">%</template></el-input>
          <span>返点比例:50代表返点50% 30代表返点30%</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '../apis/Rebate'
import MAPI from '../apis/match'

export default {
  props: ['matchId'],
  data() {
    return {
      isLoading: false,
      dialogFormVisible: false,
      multipleSelection: [],
      total: 0,
      showMatchRebate: false,
      tableListData: [],
      searchForm: {
        matchId: this.matchId,
        name: null,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        name: '',
        amount: '',
        rate: '',
        matchId: this.matchId
      },
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        rate: [{ required: true, message: '请输入比率', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入返点门槛', trigger: 'blur' }]
      }
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
    },
    setRebateStatus() {
      MAPI.setRebateStatus({ matchId: this.matchId, status: this.showMatchRebate }).then(res => {
        if (res && res.code == 0) {
          if (this.showMatchRebate) {
            this.$message.success({ showClose: true, message: "已经启用显示代表队返点", duration: 2000 });
          } else {
            this.$message.success({ showClose: true, message: "已经停用显示代表队返点", duration: 2000 });
          }
        }
        else {
          this.$message.error({ showClose: true, message: res.message, duration: 2000 });
        }
      })
    },
    editRebate(row) {
      this.formTitle = "编辑";
      API.get({ id: row.id }).then(result => {
        this.dialogFormVisible = true
        this.form = Object.assign({}, result.result)
      })
    },
    addRebate() {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        this.form.matchId = this.matchId
      })
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    doSearch() {
      this.searchForm.page = 1
      this.search()
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data;
          this.total = result.result.recordCount;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm() {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogFormVisible = false;
                that.$refs['form'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: '更新失败', duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.add(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.$refs['form'].resetFields();
                this.dialogFormVisible = false;
                this.search();
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: '新增失败', duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    },
    deleteRebate(row) {
      let params = { id: row.id };
      this.$confirm('确认删除记录吗？', '提示', { type: 'warning' }).then(() => {
        API.delete(params).then((result) => {
          console.log(result)
          if (result.code == 0) {
            this.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            this.search();
          } else {
            this.$message.error({ showClose: true, message: '系统错误', duration: 2000 });
          }
        }).catch((error) => {
          this.$message.error({ showClose: true, message: '123', duration: 2000 })
        })
      }).catch(() => { })
    },
    /*批量删除*/
    delMulData() {
      let that = this;
      let val = that.multipleSelection
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() }).then(function (result) {
            that.loading = false;
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '删除操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    }
  },
  mounted() {
    this.search()
    MAPI.get({ matchId: this.matchId }).then(res => {
      if (res != null && res.code == 0) {
        this.showMatchRebate = res.result.isShowRebate
      }
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Rebate.vue